import React, { useState } from 'react'
import { Formik, Form } from 'formik';
import {
    AddContainer, Component4,
    Texts,
    InputTextComponent,

} from './Styles';

function EducationInfoStep({ innerRef, data, setDoctorProfileData }) {
    const initialValues = {
        schoolInformation: data?.schoolInformation || '',
        collegeInformation: data?.collegeInformation || '',
        specialisationInformation: data?.specialisationInformation || ''
    }
    const handleSubmit = (values) => {
        setDoctorProfileData(prev => ({
            ...prev,
            educationalInfo: values
        }));
    }

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                innerRef={innerRef}

            >

                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, }) => (
                    <Form>
                        <AddContainer>
                            <Component4>
                                <Texts>School Information</Texts>
                                <InputTextComponent
                                    name="schoolInformation"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.schoolInformation}
                                    onChange={handleChange}
                                />
                            </Component4>
                            <Component4>
                                <Texts>College Information</Texts>
                                <InputTextComponent
                                    name="collegeInformation"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.collegeInformation}
                                    onChange={handleChange}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Specialisation Information</Texts>
                                < InputTextComponent
                                    name="specialisationInformation"
                                    placeholder="Enter"
                                    variant="outlined"
                                    value={values.specialisationInformation}
                                    onChange={handleChange}
                                />
                            </Component4>

                        </AddContainer>

                    </Form>
                )}
            </Formik>

        </>
    )
}

export default EducationInfoStep;

